<template>
    <view-card headline="결제증빙정보" :disabled="!isConsole">
        <v-select v-model="type" :items="['현금영수증', '세금계산서', '미발급']" @input="sync" label="증빙방식" placeholder=" " hide-details />
        <v-divider v-if="type !== '미발급'" class="my-4" />
        <template v-if="type == '현금영수증'">
            <v-select v-model="tradeUsage" :items="tradeUsageTypes" @input="sync" label="거래구분" placeholder=" " hide-details class="mt-4" />
            <v-text-field v-model="identityNum" @input="sync" :label="identityNumLabels[tradeUsage]" placeholder=" " hide-details class="mt-4" />
        </template>
        <template v-else-if="type == '세금계산서'">
            <v-select v-model="invoiceeType" :items="invoiceeTypes" @input="sync" label="공급받는자 구분" placeholder=" " hide-details class="mt-4" />
            <v-text-field v-model="invoiceeCorpNum" @input="sync" label="공급받는자 사업자등록번호" placeholder=" " hide-details class="mt-4" />
            <v-text-field v-model="invoiceeCorpName" @input="sync" label="공급받는자 상호" placeholder=" " hide-details class="mt-4" />
            <v-text-field v-model="invoiceeCEOName" @input="sync" label="공급받는자 대표자성명" placeholder=" " hide-details class="mt-4" />
            <v-text-field v-model="invoiceeEmail1" @input="sync" label="공급받는자 이메일" placeholder=" " hide-details class="mt-4" />
        </template>
    </view-card>
</template>
<script>
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard },
    props: {
        value: { type: Object, default: null },
    },
    data() {
        return {
            type: null,
            // 현금영수증
            tradeUsage: null,
            identityNum: null,
            tradeUsageTypes: ["소득공제용", "지출증빙용"],
            identityNumLabels: {
                ["소득공제용"]: "식별번호 (주민등록/휴대폰/카드번호 중 택 1)",
                ["지출증빙용"]: "식별번호 (사업자번호/주민등록/휴대폰/카드번호 중 택 1)",
            },
            // 세금계산서
            invoiceeType: null,
            invoiceeCorpNum: null,
            invoiceeCorpName: null,
            invoiceeCEOName: null,
            invoiceeEmail1: null,
            invoiceeTypes: ["사업자", "개인", "외국인"],
        };
    },
    computed: {
        isConsole() {
            return this.$store.state.payload.scope.includes("console");
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.type = this.value.type;
            this.value.data.forEach((item) => (this[item.key] = item.value));
        },
        sync() {
            const { type, tradeUsage, identityNum, invoiceeType, invoiceeCorpNum, invoiceeCorpName, invoiceeCEOName, invoiceeEmail1 } = this;
            this.$emit("input", {
                type,
                data: [
                    { key: "tradeUsage", value: tradeUsage },
                    { key: "identityNum", value: identityNum },
                    { key: "invoiceeType", value: invoiceeType },
                    { key: "invoiceeCorpNum", value: invoiceeCorpNum },
                    { key: "invoiceeCorpName", value: invoiceeCorpName },
                    { key: "invoiceeCEOName", value: invoiceeCEOName },
                    { key: "invoiceeEmail1", value: invoiceeEmail1 },
                ],
            });
        },
    },
    watch: {
        "value.type"() {},
    },
};
</script>
